import React from 'react';
import Modal from 'components/UI/DialogModal';
import { CircularProgress, Grid, Typography } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';



interface Props {
  open: boolean;
  loading: boolean;
  title: string;
  description: string;
  buttonText?: string;
  onClose: () => void;
  onSubmit: () => void;
}




const DeleteModal: React.FC<Props> = ({ open, loading, title, description, buttonText, onClose, onSubmit }) => {
  return (<>
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      children={<Grid container p={2}>
        <Typography variant="h6">{description}</Typography>
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="outlined"
            sx={{ color: 'warning.main', borderColor: 'warning.main' }}
            size='large' onClick={onClose}>
            {'Cancel'}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'error.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {buttonText || 'Delete'}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default DeleteModal;
